"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  UtmRoles: () => UtmRoles,
  getURLParams: () => getURLParams,
  notAudienceUsers: () => notAudienceUsers,
  useUtm: () => useUtm
});
module.exports = __toCommonJS(src_exports);

// src/interfaces/utmRoles.ts
var UtmRoles = /* @__PURE__ */ ((UtmRoles2) => {
  UtmRoles2["INTERNO"] = "interno";
  UtmRoles2["TESTING"] = "testing";
  UtmRoles2["TOTEM"] = "totem";
  UtmRoles2["BROADCAST"] = "broadcast";
  UtmRoles2["ADMIN_DASHBOARD"] = "admin_dashboard";
  UtmRoles2["VIDEO_COMMERCE"] = "video_commerce";
  UtmRoles2["APP_VIEW"] = "appview";
  return UtmRoles2;
})(UtmRoles || {});
var notAudienceUsers = [
  "broadcast" /* BROADCAST */,
  "admin_dashboard" /* ADMIN_DASHBOARD */,
  "interno" /* INTERNO */,
  "testing" /* TESTING */
];

// src/hooks/useUTM.ts
var useUtm = (utmMedium) => {
  const isAllowedToJoinCall = utmMedium === "testing" /* TESTING */ || utmMedium === "admin_dashboard" /* ADMIN_DASHBOARD */;
  const showUIComponents = utmMedium !== "broadcast" /* BROADCAST */ && utmMedium !== "admin_dashboard" /* ADMIN_DASHBOARD */;
  const isTotemDevice = utmMedium === "totem" /* TOTEM */;
  const allowFullScreen = utmMedium === "video_commerce" /* VIDEO_COMMERCE */;
  const isAppView = utmMedium === "appview" /* APP_VIEW */;
  return {
    isAllowedToJoinCall,
    isTotemDevice,
    showUIComponents,
    allowFullScreen,
    isAppView,
    isAudience: !notAudienceUsers.includes(utmMedium)
  };
};

// src/utils/utmUtils.ts
function getURLParams() {
  var _a, _b, _c;
  const searchParams = new URLSearchParams(window.location.search);
  return {
    utmSource: (_a = searchParams.get("utm_source")) != null ? _a : "",
    utmMedium: (_b = searchParams.get("utm_medium")) != null ? _b : "",
    utmCampaign: (_c = searchParams.get("utm_campaign")) != null ? _c : ""
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UtmRoles,
  getURLParams,
  notAudienceUsers,
  useUtm
});
